import { gql } from "@apollo/client"
import { ENROLLMENT_COST_CONTRIBUTION_FIELDS } from "~/shared/fragments/EnrollmentCostContributionFields"

export const ENROLLMENT_COST_CONTRIBUTIONS_FRAGMENT = gql`
  ${ENROLLMENT_COST_CONTRIBUTION_FIELDS}
  fragment EnrollmentCostContributionsFragment on BenefitsEnrollment {
    enrollmentCostContributions {
      collection {
        ...EnrollmentCostContributionsFields
      }
    }
  }
`
